import { INITIAL_PLAYER_STATS, LEVEL_UP_GROWTH } from "./config/stats.js";
export const EXPERIENCE_CURVE = { base: 100, exponent: 1.5 };
/** Experience required to advance from `level` to `level + 1`. */
export function experienceForLevel(level) {
    return Math.round(EXPERIENCE_CURVE.base * Math.pow(level, EXPERIENCE_CURVE.exponent));
}
/**
 * Stats are a pure function of level rather than an accumulator, so repeated
 * level-ups cannot drift away from the configured growth.
 */
export function statsForLevel(level) {
    const steps = Math.max(0, level - 1);
    return {
        maxHealth: INITIAL_PLAYER_STATS.maxHealth + steps * LEVEL_UP_GROWTH.maxHealth,
        maxEnergy: INITIAL_PLAYER_STATS.maxEnergy + steps * LEVEL_UP_GROWTH.maxEnergy,
        baseDamage: INITIAL_PLAYER_STATS.baseDamage + steps * LEVEL_UP_GROWTH.baseDamage,
    };
}
/** Adds experience and carries the remainder through as many levels as it covers. */
export function addExperience(level, experience, amount) {
    let nextLevel = level;
    let nextExperience = experience + Math.max(0, amount);
    let levelsGained = 0;
    while (nextExperience >= experienceForLevel(nextLevel)) {
        nextExperience -= experienceForLevel(nextLevel);
        nextLevel += 1;
        levelsGained += 1;
    }
    return { level: nextLevel, experience: nextExperience, levelsGained };
}
//# sourceMappingURL=progression.js.map